import { Route } from "react-router";
import { SALES_PURCHASES } from "@routes/routes";
import { SalesPurchasesPage } from "@routes/lazyPages";

export const purchaseRoutes = (
  <Route path={SALES_PURCHASES} lazy={SalesPurchasesPage} />
);
